import React, { Suspense, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPage from '@pages/error/ErrorPage';
import { detectDevice } from '@utils/helpers/detectdevice';
import { useStore } from 'jotai';
import {
  haveAccountSection,
  haveBackButton,
  haveBottomNavbar,
  haveFullLogo,
  haveSubjectMenu,
  haveTitle,
  haveTopNavbar,
  resetToDefaultNavbarState,
} from '@atom/navbarAtom';
const Fullchat = React.lazy(() => import('genieask/full-chat'));

const Fullchatpage = () => {
  const store = useStore();

  const googleLink: string =
    '"https://play.google.com/store/apps/details?id=com.geniebook.android';
  const iosLink: string =
    'https://apps.apple.com/sg/app/geniebook-learning-app/id905900825';
  const [, setDeviceLink] = useState<string>('');

  //* this function is used to get the operating system that open the website
  useEffect(() => {
    const device = detectDevice();
    if (device === 'iOS' || device == 'MacOS') {
      setDeviceLink(iosLink);
    } else {
      setDeviceLink(googleLink);
    }

    // navbar state
    store.set(haveTopNavbar, false);
    store.set(haveBottomNavbar, true);
    store.set(haveBackButton, false);
    store.set(haveSubjectMenu, false);
    store.set(haveTitle, false);
    store.set(haveFullLogo, true);
    store.set(haveAccountSection, true);

    return () => {
      resetToDefaultNavbarState();
    };
  }, []);

  const errorLayout = () => {
    return <ErrorPage code="500" showNavBar={false} />;
  };

  return (
    <div className="genieask-fullchat">
      <Helmet>
        <title>Geniebook - Genieask</title>
        <meta name="description" content="Genieask" />
      </Helmet>
      <div id="genieask_container">
        <ErrorBoundary fallback={errorLayout()}>
          <Suspense>
            <Fullchat />
          </Suspense>
        </ErrorBoundary>
      </div>
    </div>
  );
};

export default Fullchatpage;
